import { Link } from "react-router-dom";

const LINKS = [
  { to: "/mentions-legales", label: "Mentions légales" },
  { to: "/cgv", label: "CGV" },
  { to: "/remboursement", label: "Remboursement" },
  { to: "/conditions-utilisation", label: "Conditions d'utilisation" },
  { to: "/politique-confidentialite", label: "Politique de confidentialité" },
  { to: "/status", label: "Statut des services" },
  { to: "/recrutement", label: "Rejoindre l'équipe" },
];

export default function SiteFooter() {
  return (
    <footer className="py-12 border-t border-border-default" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row justify-between items-center gap-6">
          <div className="flex items-center gap-3">
            <img src="/images/logo-navbar.png" alt="VantaPulse" className="w-10 h-10 rounded-full object-cover" />
            <span className="font-heading font-bold text-xl">VantaPulse</span>
          </div>
          <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-text-secondary">
            {LINKS.map((link) => (
              <Link key={link.to} to={link.to} className="hover:text-white transition-colors">{link.label}</Link>
            ))}
          </nav>
          <p className="text-text-muted text-sm">© {new Date().getFullYear()} Vanta Pulse. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
}
